module.exports = __webpack_public_path__ + "img/480px-Unofficial_JavaScript_logo_2.svg-min.7f1e4c59.png";